<template>
  <div>
    <el-dialog
      class="store-dialog"
      :title="action_type === 'remove' ? '查看绑定门店' : '绑定门店'"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :before-close="cancelAction"
      width="1100px"
    >
      <!-- 查询区 -->
      <ul class="search-btn">
        <li>
          <span class="m-r-6">销售群组</span>
          <SpSearchGroup @changeGroup="changeGroup" />
        </li>
        <li>
          <span class="m-r-6">门店编号</span>
          <el-input
            v-model="params.store_bn"
            placeholder="请输入内容"
            class="input-m m-r-6"
            clearable
          />
        </li>
        <li>
          <span class="m-r-6">门店名称</span>
          <el-input
            v-model="params.store_name"
            placeholder="请输入内容"
            class="input-m m-r-6"
            clearable
          />
        </li>
        <li>
          <el-button
            type="primary"
            @click="searchList"
          >
            查询
          </el-button>
          <el-button
            type="text"
            @click="refreshStore"
          >
            同步门店
          </el-button>
        </li>
      </ul>

      <div style="margin-bottom: 15px" />
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="storeData"
        tooltip-effect="dark"
        :row-key="getRowKeys"
        @select="handleSelectionChange"
        @select-all="selectAll"
      >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="50"
        />
        <el-table-column
          prop="store_bn"
          min-width="100px"
          label="门店编号"
        />
        <el-table-column
          prop="store_name"
          label="门店"
          min-width="400px"
        />
        <el-table-column
          v-if="action_type === 'remove'"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="haddleUnBind(scope.row)"
            >
              解绑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tr" />
      <div
        slot="footer"
        class="dialog-footer select-footer"
      >
        <div>
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="params.page"
            :total="total_count"
            :page-size="params.page_size"
            @current-change="handleCurrentChange"
          />
        </div>
        <div>
          <span class="m-r-6">已选中{{ multipleSelection.length }}个门店</span>
          <el-button
            v-if="action_type === 'remove'"
            type="primary"
            :loading="submitLoading"
            @click="haddleUnBind"
          >
            全部解绑
          </el-button>
          <el-button
            v-else
            type="primary"
            :loading="submitLoading"
            @click="bindStoreAction"
          >
            确定绑定
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="解绑确认"
      :visible.sync="bindSubmitDialog"
      width="30%"
    >
      <div>
        <div>请确认解除当前导购绑定的门店</div>
        <div>
          <el-checkbox v-model="checkedBind">
            今日不再提示当前操作
          </el-checkbox>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="bindSubmitDialog = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitUnBindLoading"
          @click="submitUnBind"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBindStoreList, getNotBindStoreList, updateStore } from '@/api/staffManagement/salesman'
export default {
  props: ['storeVisible', 'action_type', 'setStoreRow'],
  data () {
    return {
      loading: false,
      storeData: [],
      multipleSelection: [],
      total_count: 0,
      params: {
        page: 1,
        page_size: 10,
        region: '',
        store_name: '',
        store_bn: ''
      },

      submitLoading: false,
      bindSubmitDialog: false, //解绑确认弹窗
      checkedBind: false, //确认绑定的弹窗提示
      unBindItem: {},
      showCheckedBind: true, //是否展示解绑弹窗提示
      submitUnBindLoading: false //确认解绑弹窗的确定加载
    }
  },
  computed: {
    showDialog () {
      return this.storeVisible
    }
  },
  watch: {
    storeVisible (newVal, oldVal) {
      if (newVal) {
        this.params.page = 1
        this.params.salesperson_id = this.setStoreRow.salesperson_id
        this.getNewsList('getFirst')
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.store_id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getNewsList()
    },

    // 查询门店
    searchList () {
      this.params.page = 1
      this.getNewsList()
    },

    // 全选事件
    selectAll (val) {
      this.multipleSelection = val
    },
    // table表格选择
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('closeStoreDialog')
      this.multipleSelection = []
      this.$refs.multipleTable.clearSelection()
    },
    // 解绑弹窗展示与否
    haddleUnBind (item) {
      if (item) {
        this.unBindItem = item
      }
      if (this.getCheckedTime()) {
        // 展示弹窗
        this.bindSubmitDialog = true
        this.checkedBind = false
      } else {
        // 直接提交
        this.submitUnBind()
      }
    },
    // 解绑操作的确定
    submitUnBind () {
      if (this.checkedBind && this.showCheckedBind) {
        localStorage.setItem(
          'bindPrompt',
          JSON.stringify({
            name: 'bindPrompt',
            value: true,
            time: new Date().getTime()
          })
        )
      }
      if (this.showCheckedBind) {
        this.submitUnBindLoading = true
      }
      if (this.unBindItem && this.unBindItem.store_id) {
        this.unBindStoreAction(this.unBindItem)
      } else {
        this.bindStoreAction()
      }
    },

    // 单个解绑
    unBindStoreAction (item) {
      let params = {
        employee_status: this.setStoreRow.employee_status,
        salesperson_id: this.setStoreRow.salesperson_id,
        store_ids: item.store_id.toString(),
        action_type: this.action_type
      }
      this.saveStore(params, 'only')
    },
    // 批量操作 绑定/解绑
    bindStoreAction () {
      if (this.setStoreRow.employee_status === 1) {
        // 员工只可绑定一个门店
        if (this.multipleSelection.length > 1) {
          this.$message.error('员工只可绑定一个门店')
        } else {
          this.submitLoading = true
          // 保存storeIds
          let storeIds = []
          this.multipleSelection.forEach((v) => {
            storeIds = storeIds.concat(v.store_id)
          })
          let params = {
            employee_status: this.setStoreRow.employee_status,
            salesperson_id: this.setStoreRow.salesperson_id,
            store_ids: storeIds.join(','),
            action_type: this.action_type
          }
          this.saveStore(params)
        }
      } else {
        // 编外可绑定多个门店
        this.submitLoading = true
        // 保存storeIds
        let storeIds = []
        this.multipleSelection.forEach((v) => {
          storeIds = storeIds.concat(v.store_id)
        })
        let params = {
          employee_status: this.setStoreRow.employee_status,
          salesperson_id: this.setStoreRow.salesperson_id,
          store_ids: storeIds.join(','),
          action_type: this.action_type
        }
        this.saveStore(params)
      }
    },

    // 调用绑定/解绑接口
    async saveStore (params, type) {
      const data = await updateStore(params).catch(() => {
        this.submitLoading = false
        this.submitUnBindLoading = false
      })
      if (data) {
        let message = this.action_type === 'add' ? '绑定成功' : '解绑成功'
        this.$message({
          message,
          type: 'success'
        })
        if (type === 'only') {
          this.unBindItem = {}
        } else {
          this.$emit('closeStoreDialog')
          this.submitLoading = false
        }
        this.searchList()
        this.bindSubmitDialog = false
        this.submitUnBindLoading = false
        this.multipleSelection = []
        this.$refs.multipleTable.clearSelection()
        this.$emit('saveStoreAction')
      }
    },
    // 获取门店列表
    async getNewsList (type) {
      this.loading = true
      if (this.action_type === 'add') {
        // 绑定操作 获取未绑定的门店列表
        const data = await getNotBindStoreList(this.params)
        if (data) {
          if (data.total_count < 1 && type === 'getFirst') {
            this.refreshStore('first')
          }
          this.loading = false
          this.storeData = data.list
          this.total_count = data.total_count
        }
      } else if (this.action_type === 'remove') {
        // 解绑操作 获取已经绑定的门店列表
        const data = await getBindStoreList(this.setStoreRow.salesperson_id, this.params)
        if (data) {
          this.loading = false
          this.storeData = data.store_list
          this.total_count = data.store_count
        }
      }
    },
    // 获取是否展示解绑弹窗
    getCheckedTime () {
      let showCheckedBind = true
      let checkedBindParams = JSON.parse(localStorage.getItem('bindPrompt'))
      if (checkedBindParams && checkedBindParams.value) {
        let time = new Date().getTime()
        if (time - checkedBindParams.time >= 24 * 60 * 60 * 1000) {
          showCheckedBind = true
        } else {
          showCheckedBind = false
        }
      } else {
        showCheckedBind = true
      }
      this.showCheckedBind = showCheckedBind
      return showCheckedBind
    },

    // 同步更新门店
    async refreshStore (type) {
      const data = await this.$api.component.refreshStore()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    },

    // 群组查询
    changeGroup (val) {
      if (val && val.length > 0) {
        this.params.group_code = val[val.length - 1]
      } else {
        this.params.group_code = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
